import Background from '../../../shared/images/onboardingBackground.svg';
import Button from '@planday-corp/ui/actions/Button';
import Icon from '@planday-corp/ui/icons/Icon';
import InlineSpinner from '@planday-corp/ui/indicators/InlineSpinner';
import styled, {css} from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    height: auto;
    position: static;
  }
`;

const COLUMN_STYLES = css`
  flex-basis: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const LeftColumn = styled.div`
  ${COLUMN_STYLES}
`;

export const RightColumn = styled.div`
  ${COLUMN_STYLES}
  background-image: linear-gradient(
      rgba(120, 120, 120, 0.2),
      rgba(120, 120, 120, 0.2)
    ),
    url('${Background}');
  background-size: cover;
  background-position: center;
`;

export const VacationImage = styled.img`
  width: 15rem;
  height: 15rem;
`;

export const SectionContainer = styled.div`
  max-width: 25rem;
  margin: 1rem;
`;

export const StyledTextWrapper = styled.div`
  padding: 4rem 1rem 1rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const SectionContentWrapper = styled.div`
  padding: 1rem 1rem 0;
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const StyledSpinner = styled(InlineSpinner)`
  width: 2.5rem;
  height: 2.5rem;
`;

export const StyledIcon = styled(Icon)`
  width: 3rem;
  height: 3rem;
  margin: -0.25rem;
`;

export const StyledButton = styled(Button)`
  margin-top: 1.8rem;
`;
